import React from "react";
import Logo from '../../../assets/Logo-02.png';
import Logo40th from '../../../assets/Logo 40th 1.png';
import Bunga from '../../../assets/Bunga.png';
import moment from "moment";
import Barcode from 'react-barcode';
import 'moment/locale/id';
moment.locale('id');

export class ComponentToPrint extends React.PureComponent {
  render() {
    const numberFormat = (value) =>
      new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value);


    var birthdateTimeStamp = new Date(this.props.item.TANGGAL_LAHIR);
    var cur = new Date();
    var diff = cur - birthdateTimeStamp;
    var currentAge = Math.floor(diff / 31557600000);

    return (
      <div className='hide-print'>
        <div
          className="container-fluid"
          style={{
            // maxWidth: "1240px",
            // maxHeight: "874px",
            // backgroundImage: 'url(' + { Bunga } + ')',
            // backgroundPosition: 'center',
            // backgroundRepeat: 'no-repeat',
            // backgroundSize: 'cover',

          }}
        >
          <div id="ui-view" data-select2-id="ui-view">
            <div>
              <div className="card">
                {/* <div className="card-header">Invoice
      <strong>#BBB-10010110101938</strong>
      </div> */}
                <div className="card-body">
                  <div className="row">
                    <div className="col=6" style={{ width: "50%" }}>

                      <table style={{

                      }}>
                        <tbody>

                          <tr>
                            <td>
                              <img
                                src={Logo}
                                width="620"
                                alt="Logo"
                                style={{
                                  // padding: 20,
                                  display: "block",
                                }}
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <p
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "20px",
                                  textAlign: 'center'
                                }}
                              >contact@biomedika.co.id - www.biomedika.co.id</p>
                            </td>
                          </tr>

                        </tbody>
                      </table>


                    </div>
                    <div className="col-6" style={{ display: "block", margin: "auto" }}>
                      <div style={{
                        float: "right",
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                      }}>
                        {/* <Barcode value={this.props.item.PID_KLINIK} /> */}
                        <table style={{
                          float: "right",
                          // backgroundImage: `url("https://via.placeholder.com/500")` ,
                          // backgroundSize: '200px'
                        }}>
                          <tbody>

                            {/* <tr>
                              <td>
                                <img
                                  src={Logo40th}
                                  width="220"
                                  alt="Logo"
                                  style={{
                                    // padding: 20,
                                    // display: "block",
                                  }}
                                />

                              </td>
                            </tr> */}

                            <tr>
                              <td>
                                <p
                                  style={{
                                    fontFamily: "Montserrat",
                                    fontSize: "14px",
                                    textAlign: 'center',
                                  }}
                                >
                                  FRM/Lab/0001
                                </p>
                              </td>
                            </tr>

                          </tbody>
                        </table>


                      </div>
                    </div>

                  </div>

                  <div className="row" style={{ marginLeft: '10px', marginBottom: '0px' }}>
                    <div className="col-12" style={{ marginBottom: '0px' }}>
                      <strong
                        style={{
                          fontSize: 52,
                          fontFamily: "var(--font-family-gotham-black-regular)",
                          color: 'rgb(15, 71, 62)'
                        }}
                      >
                        PEMERIKSAAN PENUNJANG
                      </strong>
                      <p style={{ fontSize: 32, fontStyle: 'italic', marginTop: '0px', }}>SUPPORTING EXAMINATION</p>
                    </div>
                  </div>

                  <hr style={{ border: "0.5px solid #707070", marginTop: '0px' }} />
                  <form
                    style={{
                      padding: "0px 20px 0px 20px",
                      fontFamily: "Montserrat",
                      // marginTop: "24px",
                    }}
                  >
                    {/* <div className="row mb-2">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: "14px",
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          No. Kuitansi
                        </label>
                        <p>Receipt Number</p>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >

                          :{" "}{this.props.item.NO_BUKTI_LAYANAN}
                        </label>
                      </div>
                    </div> */}



                    <div className="row mb-2">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: "14px",
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          No. MR
                        </label>
                        <p>Medical Record Number</p>
                      </div>
                      <div className="col-8">


                        <table>
                          <tr>
                            <td style={{ verticalAlign: 'top', fontSize: 24, width: 10 }}>
                              <p>:</p>
                            </td>
                            <td>
                              <label
                                style={{
                                  fontSize: 24,
                                  fontWeight: "500",
                                }}
                              >
                                <Barcode height='60' value={this.props.item.NOMR} />
                              </label>
                            </td>
                          </tr>

                        </table>


                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: "14px",
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          No. Registrasi
                        </label>
                        <p>Registration Number</p>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{this.props.item.NOREG}
                        </label>
                      </div>
                    </div>



                    <div className="row mb-2">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: "14px",
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          Tanggal Layanan
                        </label>
                        <p>Service Date</p>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{moment(moment.utc(this.props.item.TGL_LAYANAN)).local().format("DD MMMM YYYY")}
                        </label>
                      </div>
                    </div>


                    <div className="row mb-2">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: "14px",
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          Nama Dokter
                        </label>
                        <p>Doctor Name</p>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{this.props.item.NAMA_DOKTER}
                        </label>
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: "14px",
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          Nama Pasien
                        </label>
                        <p>Patient Name</p>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{this.props.item.NAMA_PASIEN}
                        </label>
                      </div>
                    </div>

                    {/* <div className="row mb-2">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: "14px",
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          No. Telp
                        </label>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{this.props.item.NO_TELP}
                        </label>
                      </div>
                    </div> */}

                    {/* <div className="row mb-2">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: "14px",
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          Jenis Kelamin
                        </label>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{this.props.item.JENIS_KELAMIN}
                        </label>
                      </div>
                    </div> */}

                    <div className="row mb-2">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: "14px",
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          Umur / Jenis Kelamin
                        </label>
                        <p>Age / Gender</p>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{currentAge + " Tahun / " + this.props.item.JENIS_KELAMIN}
                        </label>
                      </div>
                    </div>

                    {/* <div className="row mb-2">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: "14px",
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          TTL
                        </label>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{this.props.item.TEMPAT_LAHIR != "" ? this.props.item.TEMPAT_LAHIR + ", " + moment(this.props.item.TANGGAL_LAHIR).format("DD-MM-YYYY") : moment(this.props.item.TANGGAL_LAHIR).format("DD-MM-YYYY")}
                        </label>
                      </div>
                    </div> */}

                    <div className="row mb-2">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: "14px",
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          Alamat
                        </label>
                        <p>Address</p>
                      </div>
                      <div className="col-8">
                        <table>
                          <tr>
                            <td style={{ verticalAlign: 'top', fontSize: 24, width: 10 }}>
                              <p>:</p>
                            </td>
                            <td>
                              <label
                                style={{
                                  fontSize: 24,
                                  fontWeight: "500",
                                }}
                              >
                                {this.props.item.ALAMAT}
                              </label>
                            </td>
                          </tr>

                        </table>


                      </div>
                    </div>


                    <div className="row mb-2">
                      <div
                        style={{
                          position: "absolute",
                          right: "36px",
                          top: "278px",
                        }}
                      >
                        {/* <QRCode
                          id="qr-gen"
                          value={qrValue}
                          size={160}
                          level={"H"}
                          //   includeMargin={true}
                          fgColor="#22485e"
                          imageSettings={{
                            src: logo_,
                            width: 20,
                            height: 20,
                            excavate: true,
                          }}
                        /> */}
                      </div>

                      {/* <div
                        style={{
                          position: "absolute",
                          right: "28px",
                          top: "460px",
                        }}
                      >
                        <Barcode format='CODE128' value={qrValue} width='2px' height='44' displayValue="false" />
                      </div> */}
                    </div>
                  </form>
                  {/* 
                  <p
                    style={{
                      fontWeight: "bold",
                      marginBottom: "12px",
                      fontFamily: "Montserrat",
                      marginLeft: "10px",
                      marginTop: "20px",
                      fontSize: 28
                    }}
                  >
                    PERINCIAN
                  </p> */}


                  <hr style={{ border: "0.5px solid #707070" }} />

                  <form
                    style={{
                      padding: "0px 20px 0px 20px",
                      fontFamily: "Montserrat",
                      // marginTop: "24px",
                    }}
                  >

                    <div className="row mb-2">
                      <div className="col-8">
                        <label
                          style={{
                            lineHeight: "14px",
                            fontSize: 24,
                            textAlign: "left",
                            textDecoration: 'underline',
                            textUnderlineOffset: '4px',
                            textDecorationThickness: '1px'
                            // borderBottom: 'red solid 1px'
                          }}
                        >
                          PEMERIKSAAN :
                        </label>
                        <p>Exam:</p>
                      </div>
                      {/* <div className="col-8">
                      </div> */}
                    </div>

                    <div className="row mb-2">
                      <div className="col-12">
                        <label
                          style={{
                            lineHeight: "24px",
                            fontSize: 24,
                            textAlign: "left",
                            marginLeft: 60
                          }}
                        >
                          {this.props.item.CATATAN_PERIKSA_LAB}
                        </label>
                      </div>
                      {/* <div className="col-8">
                        <table style={{ float: 'right', }}>
                          <tr style={{ borderBottom: '0.5px solid #707070' }}>
                            <td style={{ verticalAlign: 'top', fontSize: 24, width: 140 }}>
                              <p>Rp.</p>
                            </td>
                            <td>
                              <label
                                style={{
                                  fontSize: 24,
                                  fontWeight: "500",
                                  // textDecoration: 'underline',
                                  // textUnderlineOffset: '8px'
                                }}
                              >
                                {this.props.item.NAMA_KONSULTASI ? numberFormat(this.props.item.TOTAL_HARGA).replace("Rp", "") : ""}
                              </label>
                            </td>
                          </tr>

                        </table>

                      </div> */}
                    </div>

                    {/* <div className="row mb-2">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: "14px",
                            fontSize: 24,
                            textAlign: "left",
                            marginLeft: 60,
                            color: 'rgb(15, 71, 62)',
                            fontWeight: 'bold',
                          }}
                        >
                          Biaya Pemeriksaan
                        </label>
                        <p style={{ marginLeft: 60 }}>Test fee</p>
                      </div>
                      <div className="col-8">

                        <table style={{ float: 'right', }}>
                          <tr>
                            <td style={{ verticalAlign: 'top', fontSize: 24, width: 140 }}>
                              <p style={{
                                color: 'rgb(15, 71, 62)',
                                fontWeight: 'bold',
                              }}>Rp.
                              </p>
                            </td>
                            <td>
                              <label
                                style={{
                                  fontSize: 24,
                                  color: 'rgb(15, 71, 62)',
                                  fontWeight: 'bold',
                                }}
                              >
                                {this.props.item.NAMA_KONSULTASI ? numberFormat(this.props.item.TOTAL_HARGA).replace("Rp", "") : ""}
                              </label>
                            </td>
                          </tr>

                        </table>

                      </div>
                    </div> */}

                  </form>




                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}